var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargeStatus3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.6668 36.6663H77.9168V18.333H13.7502C8.7085 18.333 4.5835 22.458 4.5835 27.4997V77.9163H13.7502C13.7502 85.5247 19.8918 91.6663 27.5002 91.6663C35.1085 91.6663 41.2502 85.5247 41.2502 77.9163H68.7502C68.7502 85.5247 74.8918 91.6663 82.5002 91.6663C90.1085 91.6663 96.2502 85.5247 96.2502 77.9163H105.417V54.9997L91.6668 36.6663ZM27.5002 84.7913C23.696 84.7913 20.6252 81.7205 20.6252 77.9163C20.6252 74.1122 23.696 71.0413 27.5002 71.0413C31.3043 71.0413 34.3752 74.1122 34.3752 77.9163C34.3752 81.7205 31.3043 84.7913 27.5002 84.7913ZM89.3752 43.5413L98.3585 54.9997H77.9168V43.5413H89.3752ZM82.5002 84.7913C78.696 84.7913 75.6252 81.7205 75.6252 77.9163C75.6252 74.1122 78.696 71.0413 82.5002 71.0413C86.3043 71.0413 89.3752 74.1122 89.3752 77.9163C89.3752 81.7205 86.3043 84.7913 82.5002 84.7913Z",
    fill: "#70B4F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeStatus3);
export default __webpack_public_path__ + "static/media/charge-status3.ca01496444db2cf730fe68bb5f643359.svg";
export { ForwardRef as ReactComponent };